var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      enableBackground: "new 0 0 170 170"
    },
    xmlSpace: "preserve",
    viewBox: "47.2 34.7 75.6 99.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 34.7c-20.8 0-37.8 16.9-37.8 37.8 0 4.2.7 8.3 2 12.3.9 2.7 3.9 4.2 6.7 3.3 2.7-.9 4.2-3.9 3.3-6.7-1.1-3.1-1.6-6.4-1.5-9.7.4-14.1 11.8-25.7 25.9-26.4 15.7-.8 28.7 11.7 28.7 27.2 0 14.5-11.4 26.4-25.7 27.2 0 0-5.3.3-7.9.7-1.3.2-2.3.4-3 .5-.3.1-.6-.2-.5-.5l.9-4.4L81 73.4c.6-2.8-1.2-5.6-4-6.2-2.8-.6-5.6 1.2-6.2 4 0 0-11.8 55-11.9 55.6-.6 2.8 1.2 5.6 4 6.2 2.8.6 5.6-1.2 6.2-4 .1-.6 1.7-7.9 1.7-7.9 1.2-5.6 5.8-9.7 11.2-10.4 1.2-.2 5.9-.5 5.9-.5 19.5-1.5 34.9-17.8 34.9-37.7 0-20.9-17-37.8-37.8-37.8z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.7 121.7c-3.4-.7-6.8 1.4-7.5 4.9-.7 3.4 1.4 6.8 4.9 7.5 3.4.7 6.8-1.4 7.5-4.9.7-3.5-1.4-6.8-4.9-7.5z",
    style: {
      fill: "#e6007a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotLogo);
export default __webpack_public_path__ + "static/media/dot-logo.e111a884.svg";
export { ForwardRef as ReactComponent };